import { serviceUserFrag } from '../../../../../../services/types/user.types';
import { personFrag } from '../../../../../../services/types/person.types';

export const nearEndVouchersFrag = `
    id
    folderId
    folder {
        serviceId
        person {
            ${personFrag}
        }
    }
    type
    insuranceNumber
    insuranceAbbr
    insuranceType
    insuredSince
    sequenceNumber
    issueDate
    validTo
    voucherTo
    closureDate
    doctorId
    doctor {
        ${serviceUserFrag}
    }    
`;
